<template>
    <div class="agent_list_style batch_btn" :style="screenHeight">
        <div class="fixed_search" style="height: 100px">
          <div class="fixed_search_input">
            <Select v-model="employeeType" placeholder="请选择员工类型" clearable>
              <Option value="0" key="0">座席</Option>
              <Option value="1" key="1">普通员工</Option>
            </Select>
          </div>
          <div class="fixed_search_input">
            <Input v-model="employeeCode" placeholder="请输入员工编号" title="员工编号"/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="employeeName" placeholder="请输入员工姓名" title="员工姓名"/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="agentExten" placeholder="请输入员工分机" title="员工分机"/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="agentNumber" placeholder="请输入员工工号" title="员工工号"/>
          </div>
          <div class="fixed_search_input">
            <Select v-model="employeeDepartment" placeholder="请选择所属部门" clearable>
              <Option v-for="(option, index) in allDeptList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="fixed_search_input">
            <Select v-model="employeeRole" placeholder="请选择员工角色" clearable>
              <Option v-for="(option, index) in employeeList" :value="option.id" :key="index">{{option.roleName}}</Option>
            </Select>
          </div>
          <div class="fixed_search_input">
            <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
          </div>

          <div class="fixed_search_input">
            <Select v-model="agentState" placeholder="请选择员工状态" clearable>
              <Option v-for="(option, index) in agentStatusList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>

          <div v-if="'1' == sysSupportVideo" class="fixed_search_input">
            <Select v-model="supportVideo" placeholder="请选择视频座席" clearable>
              <Option v-for="(option, index) in deptMangeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div v-if="'1' == supportAiAssistant" class="fixed_search_input">
            <Select v-model="supportAi" placeholder="请选择AI助手" clearable>
              <Option v-for="(option, index) in deptMangeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div v-if="'1' == sysSupportChat" class="fixed_search_input">
            <Select v-model="supportChat" placeholder="请选择在线客服" clearable>
              <Option v-for="(option, index) in chatList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="fixed_operation_btn">
            <Button type="primary" @click="initSearch">查询</Button>
            <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
          </div>
        </div>
        <div class="public_btn" v-if="showPublicBtn">
          <Button  class="search_btn template_btn"  @click="addAgent" v-if="roleList['9_3-1']">添加</Button>
          <Button  class="search_btn template_btn" @click="importAgent" v-if="roleList['9_3-2']">导入</Button>
          <Button  class="search_btn template_btn"  @click="batchOperation('9_3-3','用户管理=>员工管理=>导出')" v-if="roleList['9_3-3']">导出</Button>
          <Button  class="search_btn template_btn"  @click="batchOperation('9_3-4','用户管理=>员工管理=>批量修改')" v-if="roleList['9_3-4']">批量修改</Button>
          <Button  class="search_btn template_btn" @click="batchOperation('9_3-5','用户管理=>员工管理=>批量删除')" v-if="roleList['9_3-5']">批量删除</Button>
        </div>
        <div class="fixed_table">
          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
          <div class="table_head">
            <table>
              <tr>
                <th class="font_style_set" style="width:2%;"><Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox></th>
                <th class="font_style_set" style="width:7%;">员工类型</th>
                <th class="font_style_set" style="width:7%;">员工编号</th>
                <th class="font_style_set" style="width:8%;">员工姓名</th>
                <th class="font_style_set" style="width:7%;">员工分机</th>
                <th class="font_style_set" style="width:7%;">员工工号</th>
                <th class="font_style_set" style="width:7%;">所属部门</th>
                <th class="font_style_set" style="width:6%;">部门经理</th>
                <th class="font_style_set" style="width:7%;">员工角色</th>
<!--                <th class="font_style_set" style="width:9%;">手机号码</th>-->
                <th class="font_style_set" style="width:8%;">热线号码</th>
                <th class="font_style_set" style="width:6%;">员工状态</th>
                <th class="font_style_set" v-if="sysSupportVideo == '1'" style="width:6%;">视频座席</th>
                <th class="font_style_set" v-if="supportAiAssistant == '1'" style="width:6%;">AI助手</th>
                <th class="font_style_set" v-if="sysSupportChat != '0'" style="width:6%;">在线客服</th>
                <th class="font_style_set" style="width:10%;border-right: 0px">操作</th>
              </tr>
            </table>
          </div>
          <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
            <table class="table_head_footer">
              <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                <td  style="width:2%;"><CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup></td>
                <td  style="width:7%;">{{item.employeeType == "1" ? "普通员工" : "座席"}}</td>
                <td  style="width:7%;">{{item.employeeCode}}</td>
                <td  style="width:8%;" :title="item.employeeName">{{item.employeeName}}</td>
                <td  style="width:7%;">{{item.agentExten}}</td>
                <td  style="width:7%;">{{item.agentNumber}}</td>
                <td  style="width:7%;" :title="item.deptParentName">{{item.employeeDepartment}}</td>
                <td  style="width:6%;">
                  <Select v-model="item.employeeManager" :disabled="item.id=='1'" @on-change="handleDeptManager(item)">
                    <Option v-for="(option, index) in deptMangeList" :value="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                </td>
                <td  style="width:7%;" :title="item.employeeRoleName">{{item.employeeRoleName}}</td>
<!--                <td  style="width:9%;" class="telephone" @click="messageOrPhone(item.employeeMobile)">{{item.employeeMobile}}</td>-->
                <td  style="width:8%;" :title="item.pstnNumber">{{item.pstnNumber}}</td>
                <td  style="width:6%;">{{item.agentStateName}}</td>
                <td style="width:6%;" v-if="sysSupportVideo == '1'">{{item.supportVideoStr}}</td>
                <td style="width:6%;" v-if="supportAiAssistant == '1'">{{item.aiAssistantStr}}</td>
                <td style="width:6%;" v-if="sysSupportChat != '0'">{{item.supportChatStr}}</td>
                <td class="template_table_btn" style="width:10%;">
                  <el-button @click="editAgent(item.id)" v-if="roleList['9_3-6']" type="text" size="medium">编辑</el-button>
                  <el-button @click="deleteAgent(item.id)" style="margin-left: 0px;" v-if="roleList['9_3-7'] && item.id!='1'" type="text" size="medium">删除</el-button>
                  <el-tooltip class="item" effect="light" content="默认账号数据不允许删除" placement="top">
                  <el-button  style="margin-left: 0px;color: #cccccc !important;cursor:not-allowed !important;" type="text" v-if="roleList['9_3-7'] && item.id=='1'" size="medium">删除</el-button>
                  </el-tooltip>
                  <el-button @click="editQCellCore(item.id)" style="margin-left: 0px;" :disabled="item.employeeType == '1'" type="text" v-if="roleList['9_3-8']" size="medium">归属地</el-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
        <agentEditPop @closeAgentEditPop="closeAgentEditPop" :showAgent="showAgent" :agentId="agentId" :showTitle="showTitle" :agentExtenList="agentExtenList" :departmentList="departmentList" :employeeList="employeeList"></agentEditPop>
        <agentBatchModify  @closeBatchModify="closeBatchModify" :showBatchModify="showBatchModify" :batchTitle="batchTitle" :menuId="menuId"></agentBatchModify>
        <agentImportPop @closeAgentImport="closeAgentImport" :showAgentImport="showAgentImport"></agentImportPop>
        <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
        <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
         <qcellcoreEditPop @closeQCellCoreEditPop="closeQCellCoreEditPop" :showQCellCore="showQCellCore" :placeId="placeId"></qcellcoreEditPop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    import agentEditPop from '@/components/agentManage/AgentEditPop.vue'
    import agentBatchModify from '@/components/agentManage/AgentBatchModifyPop.vue'
    import agentImportPop from '@/components/agentManage/AgentImportPop.vue'
    import publicDialerPage from '@/components/login/PublicDialerPage.vue'
    import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
    import qcellcoreEditPop from '@/components/agentManage/QCellCoreEditPop.vue'
    export default {
      name: "AgentListing",
      mixins:[publicFunClass,customerPublicBtn],
      components:{
        agentEditPop,
        agentBatchModify,
        agentImportPop,
        publicDialerPage,
        PublicSendMessage,
        qcellcoreEditPop//归属地
      },
      props:{
        pageCode:String
      },
      data(){
        return {
          supportVideo:'',
          supportAi:'',
          supportChat:'',
          showPageCount:0,
          total:0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          speedChangePage: 1,
          pageSize:20,
          employeeCode:'',
          screenHeight:{height:''},
          spinShow: true,
          employeeName:'',
          agentExten:'',
          agentNumber:'',
          pstnNumber:'',
          roleList:JSON.parse(localStorage.getItem("roleList")),
          agentId:'',
          showTitle:'添加员工',
          showAgent:false,
          showQCellCore:false,//归属地
          placeId:'',
          batchTitle:'导出提示',
          showBatchModify:false,
          showAgentImport:false,
          checkedAll:false,
          employeeDepartment:'',
          agentState:'',
          agentStatusList:[{'id': '-1', 'name': '离线'},{'id': '0', 'name': '空闲'},{'id': '1', 'name': '振铃'},{'id': '2', 'name': '通话'},{'id': '3', 'name': '保持'},{'id': '4', 'name': '后处理'},{'id': '5', 'name': '被占用'},{'id': '6', 'name': '忙碌'},{'id': '7', 'name': '离开'},{'id': '8', 'name': '仅呼出'}],
          deptMangeList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
          chatList:[{'id':'0','name':'不支持'},{'id':'1','name':'支持'},{'id':'2','name':'仅支持'}],
          tableHeight:{height:''},
          singleCheckedList:[],
          infoTableList:[],
          departmentList:[],
          agentExtenList:[],
          employeeRole:'',
          employeeList:[],
          menuId:'null',
          journalType:'null',
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          sysSupportVideo:JSON.parse(localStorage.getItem("sysSupportVideo")),
          supportAiAssistant:JSON.parse(localStorage.getItem("supportAiAssistant")),
          sysSupportChat:JSON.parse(localStorage.getItem("sysSupportChat")),
          allDeptList:[],
          employeeType:'',
          queryParam: null,
        }
      },
      methods:{
        handleDeptManager:function(event){
          let that=this;
          let param={
            type:event.employeeManager,
            id:event.id,
            journalType:"用户管理=>员工管理=>修改部门经理权限",
            menuId:"null"
          };
          this.spinShow=true;
          this.$http.post("employee/doDeptManager.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("部门经理设置成功");
          });
        },
        closeAgentEditPop:function(flag){
          this.showAgent=false;
          if(flag){
            this.initSearch();
          }
        },
        closeQCellCoreEditPop:function(){//关闭归属地
             this.showQCellCore=false;
        },
        //关闭批量选择
        closeBatchModify:function(flag,operateStyle,pstnNumberList){
          this.showBatchModify=false;
          if(flag){
            //选中结果
            if(operateStyle=='0'){
              if(this.singleCheckedList.length==0){
                this.$Message.info("请选择要操作的数据!")
                return false
              }
            }
            let newList = JSON.parse(JSON.stringify(this.singleCheckedList));
            if(this.menuId=="9_3-4" && operateStyle=='0'){
              //按选中结果批量修改，需要过滤掉普通员工
              for(let i=newList.length-1;i>=0;i--){
                let item = this.infoTableList.find(item => item.employeeType === "1" && item.id === newList[i]);
                if(item){
                  newList.splice(i,1);
                }
              }
              if(!newList || newList.length <= 0){
                this.$Modal.info({
                  title:'提示',
                  content:"无符合修改项"
                });
                return false
              }
            }
            
            let param={
              journalType:this.journalType,
              menuId:this.menuId,
              ids:newList.toString(),
              type:operateStyle
            };
            //搜索结果
            if(operateStyle=='1'){
              if(this.infoTableList.length==0){
                if(this.menuId=="9_3-4"){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前没有可修改的数据"
                  });
                  return false;
                }
                if(this.menuId=="9_3-5"){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前没有可删除的数据"
                  });
                  return false;
                }
                this.$Modal.info({
                  title:'提示',
                  content:"当前没有可导出的数据"
                });
                return false;
              }
              if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再操作"
                    });
                    return false;
              }

            delete this.queryParam["pageNum"];
            delete this.queryParam["pageSize"];

            this.$set(this.queryParam, 'type', operateStyle);
            this.$set(this.queryParam, 'journalType', this.journalType);
            this.$set(this.queryParam, 'menuId', this.menuId);

              param = this.queryParam;
            }
            let url="employee/exportEmployee.json";
            if(this.menuId=="9_3-3"){
                this.$Loading.start();
                this.operateExcelExport(param,url);
                return false;
            }
            if(this.menuId=="9_3-4"){
              param.pstnNumberList=pstnNumberList;
              url="employee/updatePstnNumber.json";
            }
            if(this.menuId=="9_3-5"){
              url="employee/doDeletes.json";
            }
            let that=this;
            this.$http.post(url,param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("操作成功");
              that.initSearch();
            });
          }
        },
        //导入回调函数
        closeAgentImport:function(flag){
          this.showAgentImport=false
          if(flag){
            this.initSearch();
          }
        },
        //导入
        importAgent:function(){
          this.showAgentImport=true
        },
        //批量操作
        batchOperation:function(menuId,journalType){
          this.batchTitle="导出员工";
          if(menuId=="9_3-4"){
            this.batchTitle="批量修改员工";
          }
          if(menuId=="9_3-5"){
            this.batchTitle="批量删除员工";
          }
          this.journalType=journalType;
          this.menuId=menuId;
          this.showBatchModify=true;
        },
        addAgent:function(){
          this.showAgent=true;
          this.agentId="";
          this.showTitle="添加员工";
        },
        editAgent:function(id){
          this.showAgent=true;
          this.agentId=id+'';
          this.showTitle="编辑员工";
        },
        editQCellCore:function(id){
          this.showQCellCore=true;
          this.showTitle="归属地";
          this.placeId=id+'';
        },

        deleteAgent:function(id){
          let param={
            journalType:"用户管理=>员工管理=>删除",
            menuId:"9_3-7",
            id:id
          };
          let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定删除",
            onOk: () => {
              that.$http.post("employee/deleteEmp.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("删除成功");
                that.initSearch();
              })
            }
          });
        },
        reset:function(){
          this.employeeCode='';
          this.employeeName='';
          this.agentExten='';
          this.pstnNumber='';
          this.employeeDepartment='';
          this.agentState='';
          this.employeeRole='';
          this.agentNumber="";
          this.supportVideo="";
          this.supportAi="";
          this.supportChat="";
          this.employeeType="";
        },
        initSearch:function () {
          let that=this;
          this.spinShow=true;
          let param={
            employeeCode:this.employeeCode,//员工编号
            employeeName:this.employeeName,//员工姓名
            agentExten:this.agentExten,//座席分机
            pstnNumber:this.pstnNumber,//热线号码
            agentNumber:this.agentNumber,//员工工号
            employeeDepartment:this.employeeDepartment,//所属部门
            agentState:this.agentState,//座席状态
            employeeRole:this.employeeRole,//角色
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null",
            supportVideo:this.supportVideo,
            aiAssistant:this.supportAi,
            supportChat:this.supportChat,
            employeeType:this.employeeType,
          };
          this.queryParam = param;
          this.$http.post("employee/selectAllEmp.json",param) .then(function (res) {
            that.spinShow=false;
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let obj=res.data.obj;
            that.infoTableList=obj.list.content;
            that.agentExtenList=obj.agentExtenList;
            that.departmentList=obj.deptList;
            that.employeeList=obj.roleList;
            that.allDeptList = obj.AllDeptList;
            that.total=res.data.obj.list.totalSize;
          });
        },
      },
     created(){
       this.initPublicBtn(1,6,'9_3-');
       this.screenHeight.height=this.mountHeight(91);
       this.tableHeight.height=this.mountHeight(322);
       if (!this.showPublicBtn) {
         this.tableHeight.height=this.mountHeight(272);
       }
       this.initSearch();
     },
     watch:{
       pageCode:function () {
        //  if(this.pageCode=='9_3' && this.showPageCount==0){
        //    this.showPageCount++;
        //    this.initSearch();
        //  }
       }
     }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/agentManage/AgentListing.vue